import { Injectable, signal, computed } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private readonly counter = signal(0);
  private readonly _message = signal<string | null>(null);

  readonly loading = computed(() => this.counter() > 0);
  readonly message = this._message.asReadonly();

  show(message?: string): void {
    this.counter.update((c) => c + 1);
    if (message !== undefined) {
      this._message.set(message.trim() || null);
    } else if (!this._message()) {
      this._message.set(null);
    }
  }

  hide(): void {
    this.counter.update((c) => Math.max(0, c - 1));
    if (this.counter() === 0) {
      this._message.set(null);
    }
  }

  reset(): void {
    this.counter.set(0);
    this._message.set(null);
  }
}
